/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import "./building-material-component.scss";
import { StaticAlert, CheckboxPart } from "components";

interface TypeOfInstalationGarageType {
  field: any;
  errors?: any;
  form: any;
}

const TypeOfInstalationGarage = ({
  field,
  form,
  errors,
}: TypeOfInstalationGarageType) => {
  const [buildingMaterialObject, setBuildingMaterialObject] = useState(
    form.values.typeOfInstallations || ""
  );

  useEffect(() => {
    setBuildingMaterialObject(form.values.typeOfInstallations);
  }, [form.values[field.name]]);

  const BuildingMaterialCheckbox = [
    {
      label: "Montaż przygotowane otwory",
      value: "installationPreparedHoles",
      uuid: "installationPreparedHoles",
    },
    {
      label: "Demontaż - montaż",
      value: "disassemblyAssembly",
      uuid: "disassemblyAssembly",
    },
    {
      label: "Demontaż - montaż - obróbka tynkarska (tynk)",
      value: "disassemblyAssemblyPlaster",
      uuid: "disassemblyAssemblyPlaster",
    },
    {
      label: "Demontaż - montaż - obróbka tynkarska (GK)",
      value: "disassemblyAssemblyGK",
      uuid: "disassemblyAssemblyGK",
    },
  ];

  const handleCheckMaterial = (item: any) => {
    if (buildingMaterialObject === item.value) {
      setBuildingMaterialObject("");
    } else {
      setBuildingMaterialObject(item.value);
    }
  };

  useEffect(() => {
    form.setFieldValue(field.name, buildingMaterialObject);
  }, [buildingMaterialObject]);

  return (
    <div className="building-material-component">
      <div className="am-section-heading">Rodzaj montażu</div>
      <div className="am-section-checkbox-list construction-site__list">
        {BuildingMaterialCheckbox.map((item: any) => {
          return (
            <CheckboxPart
              className="radiobox"
              onChange={() => handleCheckMaterial(item)}
              checked={buildingMaterialObject === item.value}
              key={item.value}
              label={item.label}
              uuid={item.value}
            />
          );
        })}
      </div>
      {errors && form.touched && (
        <>
          <StaticAlert
            className="am-alert"
            size="small"
            show={errors[field.name] && errors[field.name]}
            label="Te dane są obowiązkowe. Uzupełnij je, aby móc przejść dalej."
          />
        </>
      )}
      <div className="am-separator" />
    </div>
  );
};

export default TypeOfInstalationGarage;
